import React, { useEffect } from "react";
import { Layout } from "antd";
import Sidebar from "../Sidebar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import AppHeader from "../Header";
import { useQuery } from "@tanstack/react-query";
import { userProfile } from "../../services/authService";
import classes from "./layout.module.scss";
import { queryKeys } from "../../constants";
import { useDispatch } from "react-redux";
import { updateUserProfileAction } from "../../redux/action";
import Loader from "../../components/Loading";

const { Content, Footer } = Layout;

const MainLayout = ({ applyTheme, theme }) => {
  const dispatch = useDispatch();
  const user = { name: "Bill", role: "Admin" };
  const location = useLocation();
  const navigate = useNavigate();

  const { data, isLoading: isUserProfileLoading } = useQuery({
    queryKey: [queryKeys.userProfile],
    queryFn: userProfile,
  });

  if (!data?.data?.company) {
    navigate("/company-details");
  }

  useEffect(() => {
    if (data) {
      dispatch(updateUserProfileAction(data.data));
    }
  }, [data, dispatch]);

  if (isUserProfileLoading) {
    return <Loader />;
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <AppHeader
          profile_picture={data?.data?.profile_picture ?? ""}
          applyTheme={applyTheme}
          theme={theme}
        />
        <Content style={{ margin: "12px" }}>
          <div
            className={classes.outlet}
            style={{
              background:
                location.pathname === "/dashboard" ? "transparent" : "white",
              height: "100%",
            }}
          >
            <Outlet context={{ user }} />
          </div>
        </Content>
        <Footer style={{ textAlign: "center", padding: "10px 0px" }}>
          ©{new Date().getFullYear()} Radar+. All rights reserved.
        </Footer>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
